module.exports = __webpack_public_path__ + "img/首诊卡.5c443c10.png";